import wmsCnRequest from '@alife/cnc-cn-request-wms';

import { cnRequest } from './request';

window.wmsCnRequest = wmsCnRequest;
window.CnRequest = cnRequest;
export default cnRequest;
